import { render, staticRenderFns } from "./CreateEditForm.vue?vue&type=template&id=22e3361e"
import script from "./CreateEditForm.vue?vue&type=script&lang=js"
export * from "./CreateEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports